import React, { useState, useEffect } from 'react';
import { List } from 'antd-mobile';
import 'moment/locale/ru';

import Filtered from '../Filtered'

import { GET, errorCatch, Request } from 'fennec-ui'
import { unwrap } from '../../../common/Rule'
import "./index.css"
import { Action } from 'fennec-ui'
import {BlockHeaderMobile} from 'fennec-ui';

var _ = require('lodash');
const Item = List.Item;

export default function Collection(props) {
    const {
        auth,
        source,
        data,
        title,
        extra,
        size,
        modelActions,
        collectionActions,
        noheader,
        noPrint,
        noPagination,
        selection, // undefined, "radio" или "checkbox"
        listRenderItem,
        titleFunc,
        extraFunc,
        ordering,
        hideNotData
    } = props;

    // ordering: {
    //     field : "sort",
    //     action: {
    //          method: "POST",
    //          path: "/api/...",
    //          mutation: "upgrade",
    //     }
    // }

    const [loading, setLoading] = useState(false);
    const [collection, setCollection] = useState(data || []);

    const orderingField = (r) => {
        if (ordering && ordering.field) {
            if (_.isString(ordering.field)) {
                return r[ordering.field];
            }
        }
        return r.ID;
    }
    const setOrderedCollection = (collection) => {
        const data = (ordering) ? collection.sort((a, b) => {
            return orderingField(a) - orderingField(b);
        }).map((item, index) => {
            return { ...item, [ordering.field]: index };
        }) : collection;

        setCollection(data);
    };
    const unlock = () => {
        setLoading(false);
    };
    useEffect(() => {
        if (data) {
            setOrderedCollection(data);
        } else {
            GET(auth, source,
                ({ data }) => {
                    setOrderedCollection(data);
                    unlock();
                },
                (err) => errorCatch(err, unlock)
            );
        }
    }, [source, data]);

    // Table Items Selection
    const [selectionType, setSelectionType] = useState(selection || 'checkbox'); // radio
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    useEffect(() => {
        setSelectionType(selection);
    }, [selection]);

    // Events
    const {
        // Collection Only Events
        onChange,   // |
        value,      // | AntFrom Item Api
        // Collection and Model Events
        onValues, // (values, context) => { }, // если без return то просто как событие, если внутри return то замена данных
        onData,   // (values, context) => { }, // если без return то просто как событие, если внутри return то замена данных
        onClose,   // ({unlock, close}, context) => { },
        onError,  // (err, {unlock, close}) => {},
        onDispatch, // (values, context) => {}, // если не возвращает значения то посленеё будет вызван внутренний setCollection, 
        // если вернет функцию в качестве значения то эта функция будет вызвана вместо setCollection 
        // и в неё будет передано значение нового состояния
    } = props;

    // ---- AntFrom Item Api ----
    const [currentValue, setCurrentValue] = useState(value || []);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    //---------------------------

    const filters = () => {
        var f = (props.filters) ? props.filters() : [];
        return f;
    };
    const intermediate = (values, unlock, close, item, index) => {
        return Request(values, item, {
            auth,
            collection,
            setCollection: setOrderedCollection,
            onData: onData || ((values) => values.data),

            index,
            unlock,
            close,
            onValues,
            onClose,
            onError,
            onDispatch
        })
    };
    const RenderOnCollectionActions = () => {
        if (!collectionActions) return <></>;
        let values = unwrap(collectionActions());
        if (!values || !values.length) return <></>;
        return <div>
            {values.map((e, idx) => <Action
                key={idx}
                auth={auth}
                mode={"button"}
                {...{
                    ...e,
                    action: (values, unlock, close) => intermediate(values, unlock, close, e, idx),
                }}
            />)}
        </div>;
    };
    //------------ Ordering ---------------------------------------------------------------------
    //-------------------------------------------------------------------------------------------
    const view = (items) => {
        const render = (item, index) => {
            if (listRenderItem) {
                return listRenderItem(item, index);
            }
            return "" + item
        };
        return (
            <div>
                {items.map((item, index) => (
                    <div key={item.ID || index} style={{ paddingLeft: "0px" }}>
                        {render(item, index)}
                    </div>
                ))}
            </div>
        );
    };
    const titleView = () => {
        if (title || titleFunc) {
            if (titleFunc) {
                return titleFunc(title)
            } else {
                return title
            }
        }
        return <></>
    };
    const titleExtra = () => {
        if (extra || extraFunc) {
            if (extraFunc) {
                return extraFunc(extra)
            } else {
                return extra
            }
        }
        return <></>
    };
    return (
        <>
            {!noheader && <BlockHeaderMobile
                title={titleView()}
                extra={titleExtra()}
            />}
            {filters().length == 0 && <div>
                {(collection && collection.length > 0) && <div>
                    {view(collection)}
                </div>}
                {(!hideNotData && (!collection || collection.length == 0)) &&  <div style={{
                    textAlign: "center",
                    fontSize: "18px",
                    color: "rgba(0,0,0,0.4)",
                    padding: "20px 0px"
                }}>
                    <span>Нет данных</span>
                </div>}
            </div>}

            {filters().length > 0 &&
                <Filtered
                    noPrint={noPrint}
                    noPagination={noPagination || ordering}
                    size={size}
                    filters={(!ordering) ? filters() : []}
                    data={collection}
                    addition={RenderOnCollectionActions()}
                    content={items => {
                        return (
                            <div>
                                {view(items)}
                            </div>
                        )
                    }} />}
        </>
    );
}
